export default __webpack_public_path__ + "static/media/api-validator.a41d6ee3.svg";